import all from "./all";
import users from "./users";
import parcours from "./parcours";
import quizzprofile from "./quizzprofile";
import play from "./play";
import tuto from "./tuto";
import tester_niveau from "./tester_niveau";
import * as auth from "./auth";
// import auth from './auth';
import play_exo from "./exercice_zone/play_exo";
import challenge_profile from "./exercice_zone/challenge_profile";

const ReduxAxios = {
  all,
  auth,
  parcours,
  quizzprofile,
  play,
  tuto,
  tester_niveau,

  play_exo,
  challenge_profile,
};
export default ReduxAxios;
